function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#4555A5;}\r\n\t.st1{fill:#CFDCF1;}\r\n\t.st2{fill:#ED1459;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Wheel_Labs"
}, /*#__PURE__*/React.createElement("g", {
  id: "Labs"
}, /*#__PURE__*/React.createElement("path", {
  id: "S",
  className: "st0",
  d: "M739.66,336.67c0,5.59-1.04,10.69-3.12,15.31c-2.08,4.62-5.13,8.58-9.14,11.88 c-4.01,3.3-8.96,5.86-14.85,7.69c-5.89,1.83-12.59,2.74-20.11,2.74c-6.09,0-11.88-0.66-17.37-1.98c-5.48-1.32-10.38-3.5-14.7-6.55 c-4.32-3.05-7.74-7.03-10.28-11.96c-2.54-4.92-3.86-10.94-3.96-18.05h29.09c0.3,4.67,2,8.35,5.1,11.04 c3.1,2.69,7.64,4.04,13.63,4.04c5.38,0,9.42-1.01,12.11-3.05c2.69-2.03,4.04-4.72,4.04-8.07c0-2.44-0.81-4.49-2.44-6.17 c-1.62-1.68-4.42-2.97-8.38-3.88l-11.42-2.59c-10.76-2.44-18.61-6.3-23.53-11.58c-4.93-5.28-7.39-11.93-7.39-19.96 c0-5.48,1.07-10.41,3.2-14.78c2.13-4.37,5.2-8.1,9.22-11.2c4.01-3.1,8.86-5.46,14.55-7.08c5.69-1.62,12.03-2.44,19.04-2.44 c5.48,0,10.74,0.56,15.77,1.68c5.03,1.12,9.52,2.97,13.48,5.56s7.18,5.99,9.67,10.21c2.49,4.21,3.98,9.47,4.49,15.77l-28.49,3.2 c-0.71-4.57-2.34-7.92-4.87-10.05c-2.54-2.13-6.4-3.2-11.58-3.2c-4.98,0-8.71,0.89-11.2,2.67c-2.49,1.78-3.73,4.19-3.73,7.24 c0,2.34,0.79,4.32,2.36,5.94c1.57,1.63,4.39,2.89,8.45,3.81l12.03,2.74c4.87,1.12,9.16,2.51,12.87,4.19 c3.71,1.68,6.88,3.76,9.52,6.25c2.64,2.49,4.62,5.43,5.94,8.83C739,328.27,739.66,332.21,739.66,336.67z"
}), /*#__PURE__*/React.createElement("path", {
  id: "B",
  className: "st0",
  d: "M642.02,288.69c0,6.8-1.69,12.41-5.08,16.83c-3.39,4.42-8.01,7.75-13.88,9.98 c4.29,2.23,7.58,5.1,9.88,8.61c2.3,3.5,3.45,7.79,3.45,12.87c0,5.18-0.99,9.88-2.97,14.09c-1.98,4.22-4.98,7.84-8.99,10.89 c-4.01,3.05-9.04,5.41-15.08,7.08c-6.04,1.68-13.08,2.51-21.1,2.51h-46.61l23-108.76h40.98c6.7,0,12.39,0.69,17.06,2.06 c4.67,1.37,8.42,3.22,11.25,5.56c2.83,2.34,4.88,5.08,6.17,8.23C641.38,281.79,642.02,285.14,642.02,288.69z M573.17,349.47h17.52 c5.69,0,10-1.11,12.95-3.33c2.94-2.22,4.42-5.65,4.42-10.29c0-3.23-0.99-5.7-2.97-7.42c-1.98-1.71-5.31-2.57-9.98-2.57h-16.76 L573.17,349.47z M582.77,304.53h17.06c1.93,0,3.76-0.18,5.48-0.53c1.73-0.35,3.25-0.93,4.57-1.74c1.32-0.8,2.36-1.94,3.12-3.4 c0.76-1.46,1.14-3.25,1.14-5.37c0-2.82-0.97-4.96-2.89-6.42c-1.93-1.46-4.98-2.19-9.14-2.19h-14.93L582.77,304.53z"
}), /*#__PURE__*/React.createElement("path", {
  id: "A",
  className: "st0",
  d: "M497.31,350.69h-36.41l-10.51,20.87h-29.7l60.47-108.76h33.21l14.78,108.76h-29.86L497.31,350.69z  M472.79,327.38h22.39l-3.35-37.47L472.79,327.38z"
}), /*#__PURE__*/React.createElement("path", {
  id: "L",
  className: "st0",
  d: "M334.32,371.56l23-108.76h29.25l-17.67,83.93h47.83l-7.46,24.83H334.32z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Wheel"
}, /*#__PURE__*/React.createElement("path", {
  id: "L_00000056389313795505863050000011578108967902721432_",
  className: "st0",
  d: "M791.91,234.46l23-108.76h29.25l-17.67,83.93 h47.83l-7.46,24.83H791.91z"
}), /*#__PURE__*/React.createElement("path", {
  id: "E_00000146489777130457446530000003883988592079991197_",
  className: "st0",
  d: "M743.17,149.77l-3.66,17.37h45.85l-5.18,24.07 h-45.85l-3.96,19.19h51.79l-7.01,24.07H696.4l23-108.76h77.84l-5.03,24.07H743.17z"
}), /*#__PURE__*/React.createElement("path", {
  id: "E",
  className: "st0",
  d: "M647.66,149.77L644,167.13h45.85l-5.18,24.07h-45.85l-3.96,19.19h51.79l-7.01,24.07H600.9l23-108.76 h77.84l-5.03,24.07H647.66z"
}), /*#__PURE__*/React.createElement("path", {
  id: "H",
  className: "st0",
  d: "M509.96,125.7h29.25l-8.38,39.45h35.34l8.38-39.45h29.25l-23,108.76h-29.25l8.99-42.96h-35.34 l-8.99,42.96h-29.25L509.96,125.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "W",
  className: "st0",
  d: "M446.44,234.46h-30.01l-1.22-69.61l-29.86,69.61h-29.4l-6.25-108.76h31.53l-1.22,70.38l29.55-69.61 h27.72l0.61,71.14L467,125.7h30.47L446.44,234.46z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "_x35_th"
}, /*#__PURE__*/React.createElement("path", {
  id: "wheel",
  className: "st1",
  d: "M291.65,275.06c0,41.42-33.58,75-75,75c-31.16,0-57.88-19.01-69.2-46.06l71.01-20.36v-17.16 l-71.01-20.36c11.32-27.05,38.04-46.06,69.2-46.06C258.07,200.06,291.65,233.64,291.65,275.06z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Center_Dot",
  className: "st2",
  cx: 216.65,
  cy: 275.06,
  r: 8.75
}), /*#__PURE__*/React.createElement("g", {
  id: "TH"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M269.1,133.72l-5.78,26.98h-9.4l5.73-26.98h-9.38l1.67-8.02h28.23l-1.67,8.02H269.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M283.88,125.7h9.4l-2.7,12.72h9.43l2.7-12.72h9.4l-7.4,35h-9.4l2.89-13.81h-9.43l-2.89,13.81h-9.4 L283.88,125.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "_x35_",
  className: "st0",
  d: "M216.65,177.56c-15.88,0-30.85,3.79-44.09,10.5l5.79-27.37l62.49,0l7.4-35l-98.42,0.03 l-24.14,114.15l12.86,3.72c6.78,1.97,20.99,6.06,20.99,6.06v-20.84c0,0,53.55-15.24,57.12-16.26c34.52,0,62.5,27.98,62.5,62.5 c0,34.52-27.98,62.5-62.5,62.5c-8.11-2.33-57.12-16.38-57.12-16.38l0.02-20.67c0,0-23.58,6.77-33.86,9.72 c14.11,36.47,49.51,62.33,90.96,62.33c53.85,0,97.5-43.65,97.5-97.5C314.15,221.21,270.5,177.56,216.65,177.56z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var Svg5ThWhelLabLogo = function Svg5ThWhelLabLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_th_Wheel_Labs",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 500",
    style: {
      enableBackground: "new 0 0 1000 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5ThWhelLabLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5th_Whel_Lab_Logo.643bebf1.svg";
export { ForwardRef as ReactComponent };